import { api } from '@goaltree/backend/convex/_generated/api'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useAction } from 'convex/react'
import { useEffect, useRef } from 'react'

export const Route = createFileRoute('/api/gmail/callback')({
  validateSearch: (search): { code?: string; state?: string; error?: string } => ({
    code: typeof search.code === 'string' ? search.code : undefined,
    state: typeof search.state === 'string' ? search.state : undefined,
    error: typeof search.error === 'string' ? search.error : undefined,
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = useNavigate()
  const { code, state, error } = Route.useSearch()
  const completeConnection = useAction(api.apps.completeConnection)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true

    async function finish() {
      if (error || !code || !state) {
        navigate({ to: '/settings', search: { gmail: 'error' }, hash: 'apps', replace: true })
        return
      }
      try {
        const result = await completeConnection({ code, state })
        navigate({
          to: '/settings',
          search: { gmail: result.ok ? 'connected' : 'error' },
          hash: 'apps',
          replace: true,
        })
      } catch {
        navigate({ to: '/settings', search: { gmail: 'error' }, hash: 'apps', replace: true })
      }
    }

    void finish()
  }, [code, state, error, completeConnection, navigate])

  return (
    <div className="flex h-svh items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-foreground" />
    </div>
  )
}
